import { useLingui } from "@lingui/react/macro";

import { cn } from "@/shared/lib";
import type { Severity } from "@/shared/ui/severity-dot";

import { scoreSeverity } from "../../lib/scoreSeverity";

const COLORS: Record<Severity, string> = {
  good: cn("border-good/40 bg-good/10 text-good"),
  warn: cn("border-warn/40 bg-warn/10 text-warn"),
  bad: cn("border-bad/40 bg-bad/10 text-bad"),
};

const RINGS: Record<Severity, string> = {
  good: "border-good",
  warn: "border-warn",
  bad: "border-bad",
};

type MatchScoreBadgeProps = {
  score: number | null;
  // Кольцо с одним числом — для бокового меню, где «N / 100» не помещается.
  compact?: boolean;
};

// Быстрая оценка матча «N / 100»: скольких из 100 игроков ранга на этом герое игрок лучше.
// Матч ещё не оценён — в списке пустое место той же ширины, чтобы столбцы не прыгали,
// в меню — ничего.
export const MatchScoreBadge = ({ score, compact = false }: MatchScoreBadgeProps) => {
  const { t } = useLingui();
  if (score === null) {
    return compact ? null : <span aria-hidden="true" className="w-[84px] shrink-0" />;
  }
  const severity = scoreSeverity(score);
  return (
    <span
      data-score={score}
      title={t`Better than ${score} of 100 players of your rank on this hero`}
      className={
        compact
          ? cn(
              "inline-flex h-6.5 min-w-8 shrink-0 items-center justify-center rounded-full border-2 px-1.5 font-mono text-xs font-semibold text-foreground",
              RINGS[severity],
            )
          : cn(
              "inline-flex w-[84px] shrink-0 justify-center rounded-md border px-2 py-1 font-mono text-[13px] font-semibold whitespace-nowrap",
              COLORS[severity],
            )
      }
    >
      <span className="sr-only">{t`Match score:`} </span>
      {compact ? score : <>{score} / 100</>}
    </span>
  );
};
